import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import styles from './styles';
const Pill = ({ children, sx, chipVariant, backColor, borderStyle }) => {
    return (_jsx(Box, { sx: sx, children: _jsx(Chip, { label: children, variant: chipVariant || 'filled', sx: {
                ...styles.pill,
                backgroundColor: backColor || styles.pill.backgroundColor,
                ...(borderStyle && { border: borderStyle }),
            } }) }));
};
export default Pill;
